import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    
    // Auto-reload on chunk load failures (happens after deployments)
    if (
      error?.name === 'ChunkLoadError' ||
      error?.message?.includes('Loading chunk') ||
      error?.message?.includes('Loading CSS chunk') ||
      error?.message?.includes('dynamically imported module')
    ) {
      window.location.reload();
      return;
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary-fallback" className="flex flex-col items-center justify-center p-8 rounded-lg border border-red-200 bg-red-50 dark:bg-red-950/20 dark:border-red-800 m-4">
          <h3 className="text-lg font-semibold text-red-700 dark:text-red-400 mb-2">
            Something went wrong
          </h3>
          <p className="text-sm text-red-600 dark:text-red-300 mb-4 text-center max-w-md">
            {this.props.fallbackMessage || 'This section encountered an error. Please try refreshing the page.'}
          </p>
          <div className="flex gap-2">
            <button
              data-testid="error-boundary-retry"
              onClick={() => this.setState({ hasError: false, error: null })}
              className="px-4 py-2 text-sm rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors"
            >
              Retry
            </button>
            <button
              data-testid="error-boundary-reload"
              onClick={() => window.location.reload()}
              className="px-4 py-2 text-sm rounded-md bg-red-600 text-white hover:bg-red-700 transition-colors"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
